import { render, staticRenderFns } from "./PreviewForm.vue?vue&type=template&id=2e5f2594&scoped=true&"
import script from "./PreviewForm.vue?vue&type=script&lang=ts&"
export * from "./PreviewForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5f2594",
  null
  
)

export default component.exports